var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8699_275551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 105.5H115L60 10.5L5 105.5ZM65 89.2156C65 89.9249 64.4249 90.5 63.7156 90.5H56.2844C55.575 90.5 55 89.9249 55 89.2156V81.7844C55 81.075 55.575 80.5 56.2844 80.5H60H63.7156C64.4249 80.5 65 81.075 65 81.7844V89.2156ZM65 70.5H55V51.7844C55 51.075 55.575 50.5 56.2844 50.5H63.7156C64.4249 50.5 65 51.075 65 51.7844V70.5Z",
    fill: "#DB3836"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8699_275551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningError);
export default __webpack_public_path__ + "static/media/warning-error.eac4513c.svg";
export { ForwardRef as ReactComponent };